import React from 'react';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Star, Loader2, Check, X } from 'lucide-react';

export const AdminReviewsTab = ({ reviews, loading, onAction }) => {
  if (loading || !reviews) {
    return (
      <div className="flex justify-center py-20">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  const pending = reviews.filter(r => r.status === 'pending');

  return (
    <div className="space-y-6" data-testid="admin-reviews-tab">
      <div className="flex items-center gap-2">
        <Star className="w-5 h-5 text-amber-400 fill-amber-400" />
        <h2 className="text-lg font-semibold">Reviews</h2>
        {pending.length > 0 && <Badge className="bg-amber-500 text-white hover:bg-amber-500">{pending.length} pending</Badge>}
      </div>
      <p className="text-sm text-muted-foreground -mt-3">
        Approve to publish on linkmonkey.io/reviews. Reject deletes the review — the user can submit a new one.
      </p>

      {reviews.length === 0 ? (
        <Card className="p-10 text-center text-sm text-muted-foreground">No reviews submitted yet.</Card>
      ) : (
        <div className="space-y-3">
          {reviews.map(r => (
            <Card key={r.id} className="p-4" data-testid={`admin-review-${r.username}`}>
              <div className="flex items-start justify-between gap-3 flex-wrap">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className="text-sm font-semibold">{r.name} <span className="text-muted-foreground">@{r.username}</span></span>
                    <div className="flex gap-0.5">
                      {[1, 2, 3, 4, 5].map(i => (
                        <Star key={i} className={`w-3.5 h-3.5 ${i <= r.rating ? 'fill-amber-400 text-amber-400' : 'text-gray-300'}`} />
                      ))}
                    </div>
                    {r.status === 'approved'
                      ? <Badge className="bg-emerald-500 text-white hover:bg-emerald-500">Live</Badge>
                      : <Badge variant="secondary">Pending</Badge>}
                  </div>
                  <p className="text-sm text-muted-foreground">{r.text}</p>
                  <p className="text-xs text-muted-foreground/70 mt-1">{r.email} · {r.created_at ? new Date(r.created_at).toLocaleDateString() : ''}</p>
                </div>
                <div className="flex gap-2 flex-shrink-0">
                  {r.status !== 'approved' && (
                    <Button size="sm" onClick={() => onAction(r.id, 'approve')} data-testid={`approve-review-${r.username}`}>
                      <Check className="w-4 h-4 mr-1" /> Approve
                    </Button>
                  )}
                  <Button size="sm" variant="outline" className="text-red-500 hover:text-red-600"
                    onClick={() => onAction(r.id, 'reject')} data-testid={`reject-review-${r.username}`}>
                    <X className="w-4 h-4 mr-1" /> Reject
                  </Button>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};
